import { useContext } from 'react';
import TrackWrapper from '@/common/TrackWrapper';
import { contentWithNavStyles, TileGrid } from '@/new-cars/new-cars.styles';
import TruckBodyStyleCard from '@/new-cars/TruckBodyStyleSection/TruckBodyStyleCard';
import SectionName from '~/constants/new-cars/SectionName';
import { SECTION_VIEW_THRESHOLD } from '~/constants/new-cars/sectionViewThreshold';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

const viewEvent = {
  customAttributes: {
    action: 'viewed',
    level: 'Body Style',
    section: 'Body Style'
  },
  eventName: 'New Cars'
};

type OwnProps = {
  heading?: string;
};

function TruckBodyStyleSection({ heading }: OwnProps) {
  const { selectedTrim, selectedTruckBodyStyle, truckBodyStyles } =
    useContext(ParentModelContext);

  if (truckBodyStyles.data.results.length === 0) return null;

  const defaultHeading = selectedTrim?.title
    ? `Select ${selectedTrim.title} Cab/Box`
    : 'Select Cab/Box';
  const displayHeading = heading ?? defaultHeading;

  return (
    <TrackWrapper
      element="section"
      event={viewEvent}
      threshold={SECTION_VIEW_THRESHOLD}
      trackOnce
      className={contentWithNavStyles}
    >
      <h2 className="text-text-strong t-heading-xl">{displayHeading}</h2>
      <TileGrid withNav>
        {truckBodyStyles.data.results.map(truckBodyStyle => (
          <TruckBodyStyleCard
            key={truckBodyStyle.title}
            selected={
              selectedTruckBodyStyle?.truckBodyStyle ===
              truckBodyStyle.next.truckBodyStyle
            }
            truckBodyStyle={truckBodyStyle}
          />
        ))}
      </TileGrid>
    </TrackWrapper>
  );
}

export default withErrorBoundary<OwnProps>(
  TruckBodyStyleSection,
  undefined,
  undefined,
  SectionName.TruckBodyStyle
);
